import React, { useState } from 'react'
import Banner from '../components/Banner'
import { servicesData } from '../data'
import ServiceModal from '../components/ServiceModal';
import { Helmet } from 'react-helmet-async';
const Services = () => {

  const [selectedService, setSelectedService] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = (service) => {
    setSelectedService(service);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
    <Helmet>
      <title>
        Yacht Rental Services Dubai | Luxury Yacht Charter in Dubai
      </title>

      <meta name="description" content="Explore top yacht rental services in Dubai with BlueHarbour. Enjoy luxury yacht charters for private events, cruises, and tours along Dubai’s stunning coastline." />

      <meta
          name="keywords"
          content="Yacht rental dubai, Dubai yacht rental, Yacht rental dubai marina, Yachts rental dubai, Luxury yacht rental dubai, Yachts rental dubai price, Yacht rentals in dubai, Dubai yacht rentals, Party yacht rental dubai, Small yacht rental dubai, Private yacht rental dubai, Dubai yacht rental prices, Luxury yacht rental in dubai, Birthday yacht rental dubai, Yacht rental dubai for birthday, Yacht rental dubai new year’s eve, Yacht rental dubai party, Yacht rental in dubai prices, Best yacht rental dubai, Dubai marina yacht rental, Yacht rental marina dubai price, Dubai luxury yacht rental, Yacht rental dubai for couples, Luxury yacht rental dubai marina"
        />
    </Helmet>
    <main id="contact">
      <Banner img="assets/yachtimages/service-banner.webp" text="Yacht Rental Services Dubai" />
      <section className="services-section">
        <div className="container">
          <div className="row gx-5" id="two_column_absection">
            <div className="col-lg-12 my-auto">
              <div>
                <h2 className="">Luxury Yacht Rentals In Dubai- Your Escapade To A Magical Adventure </h2>
                <p>
                  A yacht journey isn’t just about sailing–it's about crafting an extraordinary experience on the open waters under the beautiful skyline. At Blue Harbour, we create moments that blend luxury, adventure, and seamless services to give you the best experience on board.
                </p>
                <p>
                  From the moment you step aboard, indulge in a world of luxury tailored to your event. Begin your experience with gourmet Dubai yacht catering, where exquisite cuisine enhances your time on the water.
                </p>
                <p>
                  Our expert yacht decorators in Dubai set the perfect ambience with breathtaking themes and elegant setups, creating an atmosphere that complements your celebration. For those seeking adventure, dive into exhilarating watersports or feel the rush with high-speed jet ski rentals.
                </p>
                <p>
                  To ensure a seamless experience from start to finish, arrive in sophistication with our luxury car transport service, offering comfort and style before you even set sail.
                </p>
              </div>
            </div>
          </div>


          <div className="row justify-content-center mt-3">
            <h3 className='mb-4 fw-bold'>Experience the perfect blend of elegance and excitement on the water—reserve your private yacht with Blue Harbour today!</h3>
            {servicesData.map((service) => (
              <div key={service.id} className="col-lg-4 col-md-4 col-sm-6 mb-3">
                <div className="card_services">
                  <div className="icon-wrapper">
                    <img src="assets/images/favicon.png" alt="" />
                  </div>
                  <h3>{service.serviceName}</h3>
                  <p>
                    {service.metaData}
                  </p>
                  <button className="btn" onClick={() => handleOpenModal(service)}>
                    Know More
                  </button>
                </div>
              </div>
            ))}

          </div>

        </div>
      </section>
      <ServiceModal service={selectedService} show={showModal} handleClose={handleCloseModal} />
    </main>
    </>
  )
}

export default Services